module.exports = __webpack_public_path__ + "img/kirovograd.27d1bd07.png";